
import { useState, useEffect } from 'react';
import { Task } from '@/types/task';
import { getTasksByDay } from '@/utils/taskUtils';

export const useTaskNavigation = (tasks: Task[]) => {
  const [dateOffset, setDateOffset] = useState(0);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  useEffect(() => {
    if (tasks.length > 0) {
      const tasksByDay = getTasksByDay(tasks, 0);
      const daysWithTasks = Object.keys(tasksByDay);
      const today = new Date();
      const currentDay = today.toLocaleDateString('en-US', { weekday: 'long' });
      
      console.log('Current date object:', today);
      console.log('Current timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone);
      console.log('Current day name:', currentDay);
      console.log('Days with tasks:', daysWithTasks);
      console.log('Today index in days with tasks:', daysWithTasks.indexOf(currentDay));
      
      // Always show current day index in days with tasks
      const todayIndex = daysWithTasks.indexOf(currentDay);
      
      // If today exists in days with tasks, show it
      // If not, show the first day with tasks
      setDateOffset(todayIndex !== -1 ? todayIndex : 0);
    }
  }, [tasks]);

  const navigateDays = (direction: 'prev' | 'next') => {
    setDateOffset(prev => {
      const tasksByDay = getTasksByDay(tasks, 0);
      const daysWithTasks = Object.keys(tasksByDay);
      const totalDays = daysWithTasks.length;
      
      if (direction === 'next') {
        return (prev + 1) % totalDays;
      } else {
        return prev === 0 ? totalDays - 1 : prev - 1;
      }
    });
  };

  const getCurrentDayName = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', { weekday: 'long' });
  };

  return {
    dateOffset,
    navigateDays,
    getCurrentDayName,
  };
};

